import { Component, Input } from "@angular/core";

@Component({
    selector: "app-fees-table-cell-content",
    templateUrl: "./fees-table-cell-content.component.html",
    styleUrls: ["./fees-table-cell-content.component.less"],
    standalone: false
})
export class FeesTableCellContentComponent {

    @Input() columnId: string;
    @Input() element: any;
    @Input() paymentAmount: number;

    get feePerc(): number {
        return (this.paymentAmount ? ((100 * this.element.feeValue) / this.paymentAmount) : 0);
    }

}
